export var EditorEventType;
(function (EditorEventType) {
    EditorEventType["updateBranding"] = "update-branding";
    EditorEventType["updatePageStructure"] = "update-page-structure";
    EditorEventType["updateComponent"] = "update-component";
    EditorEventType["navigateToPage"] = "navigate";
    EditorEventType["updateCustomFields"] = "update-custom-fields";
    EditorEventType["getCompiledTemplate"] = "get-compiled-template";
})(EditorEventType || (EditorEventType = {}));
export var EditorSetupEventType;
(function (EditorSetupEventType) {
    EditorSetupEventType["sendMessagePort"] = "send-message-port";
})(EditorSetupEventType || (EditorSetupEventType = {}));
//# sourceMappingURL=editor-events.js.map